import React from 'react';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import MobileMenuItem from './mobileMenuItem';

const MobileMenu = ({ params }) => {
  const {
    logo,
    navigation,
    secondary_navigation,
    visibleIndex,
    setVisible,
    toggleMobileMenu,
    mobileMenuOpen,
  } = params;

  const { t } = useTranslation(['header']);

  return (
    <div className="sticky z-50 w-full top-0">
      <div className="lg:hidden relative">
        <div
          className={`absolute left-0 w-full h-auto ${
            mobileMenuOpen ? 'visible top-0' : 'invisible -top-[100vh]'
          }  transition-all duration-300  bg-yellow-7.5 rounded-b z-40 min-h-[50vh]`}
        >
          <div className="w-full mx-auto py-4 px-4 md:px-12 flex justify-between">
            <Link
              to="/"
              aria-label={t('Menu')}
              data-tracking-id="mobile-menu-logo"
            >
              <span className="sr-only">{logo.alt}</span>
              <img
                className="h-11 min-w-[155px] z-20 relative"
                src={logo.filename}
                alt={logo.alt}
              />
            </Link>
          </div>
          <div className="">
            {navigation.map((nav, index) => (
              <MobileMenuItem
                nav={nav}
                index={index}
                visibleIndex={visibleIndex}
                setVisible={setVisible}
                key={nav._uid}
                trackingParent={`mobile-menu`}
              />
            ))}
            {secondary_navigation.map((nav, index) => (
              <MobileMenuItem
                nav={nav}
                index={index}
                key={nav._uid}
                trackingParent={`mobile-menu`}
              />
            ))}
          </div>
        </div>
        <div className="absolute justify-end top-6 right-2 z-50">
          <button
            className={`group inline-flex items-center  ml-1 mr-2 pl-3 pr-3 py-2 rounded-full ${
              mobileMenuOpen ? 'bg-transparent' : 'bg-white'
            }   border border-black hover:border-black/50 transition-border duration-300 ease-in-out relative z-20 font-crystalCondensed `}
            onClick={toggleMobileMenu}
            aria-label={t('Menu')}
          >
            <span
              className={`text-black ${
                mobileMenuOpen ? 'hidden' : 'hidden xs:block'
              } mr-2`}
            >
              {t('Menu')}
            </span>
            <div className="relative ">
              <div className="relative flex items-center justify-center w-[20px] h-[25px]">
                <div className="flex flex-col justify-between w-[20px] h-[10px]">
                  <div
                    className={`bg-black h-[3px] w-full rounded transform transition-all duration-300 origin-left ${
                      mobileMenuOpen
                        ? 'rotate-45 h-[3px] -translate-y-[3px] translate-x-[2px]'
                        : ''
                    } `}
                  ></div>
                  <div
                    className={`bg-black h-[3px] w-full rounded self-end transform transition-all duration-300 ${
                      mobileMenuOpen
                        ? 'translate-y-[4px] translate-x-[2px] -rotate-45 h-[3px]'
                        : ''
                    }  origin-left `}
                  ></div>
                </div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
